import React, { useState, createContext, useContext, useEffect } from "react";
import axios from "axios";

// create auth context
const authContext = createContext({ user: {} });

// context provider
const { Provider } = authContext;

// context provider wrapper
export function AuthProvider(props) {
  // hook into auth provider
  const auth = useAuthProvider();
  return <Provider value={auth}>{props.children}</Provider>;
}

// return the current auth context value
export const useAuth = () => {
  return useContext(authContext);
};

const useAuthProvider = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      setUser(JSON.parse(user));
    }
  }, []);

  // const handleAuthStateChanged = (user) => {
  //   setUser(user);
  //   if (user) {
  //     // getUserAdditionalData(user);
  //   }
  // };

  const login = (data) => {
    return axios
      .post(`${process.env.REACT_APP_BASE_API}auth/login/organization`, data)
      .then(
        (res) => {
          localStorage.setItem("user", JSON.stringify(res.data.data));
          setUser(res.data.data);
          return res;
        },
        (err) => {
          throw err;
        }
      );
  };

  const register = (data) => {
    return axios
      .post(`${process.env.REACT_APP_BASE_API}auth/register/organization`, data)
      .then(
        (res) => {
          localStorage.setItem("user", JSON.stringify(res.data.data));
          setUser(res.data.data);
          return res;
        },
        (err) => {
          throw err;
        }
      );
  };

  const forgotPassword = (data) => {
    return axios
      .post(
        `${process.env.REACT_APP_BASE_API}auth/organization/forgot-password`,
        data
      )
      .then(
        (res) => {
          return res;
        },
        (err) => {
          throw err;
        }
      );
  };

  const newPassword = (data, token) => {
    const config = {
      headers: { Authorization: `token ${token}` },
    };
    return axios
      .post(
        `${process.env.REACT_APP_BASE_API}auth/organization/recovery?token=${token}`,
        data,
        config
      )
      .then(
        (res) => {
          return res;
        },
        (err) => {
          throw err;
        }
      );
  };

  return {
    login,
    register,
    user,
    setUser,
    forgotPassword,
    newPassword,
  };
};
